import gql from 'graphql-tag'

export const paymentTypeResult = `
  type
  value
  default
`
export const propertyResult = `
  id
  address {
    country {
      name
      id
    }
    address
    locality
    administrative_area
  }
  name
  developer {
    id
    name
    image
  }
  fb_url
  fb_reaction_count
  seo_friendly_url
  description
  estimated_return
  estimated_rental_income
  property_type
  featured_image
  market_price
  featured_image
  estimated_price
  estimated_price_currency
  subscribed
  area
  apartment_info
  property_class
`

export const offerResult = `
  id
  invested
  offer_id
  start_date
  end_date
  num_of_tokens
  num_of_shares
  property_price
  monthly_income
  tokens_sold
  tokens_left
  num_of_buyers
  share_unit_amount 
  booking_amount
  status
  priority
  currency_mode
  currency
  max_shares_allowed
  shares_left
  number_viewing
  price_confirmed
  commitment_detail
  property {
    ${propertyResult}
  }
  payment_schedules {
    date
    percentage
    amount
  }
  promotion {
    pay_once_profit
    pay_installment_profit
  }
  payment_types {
    ${paymentTypeResult}
  }
  management_fee_schedule {
    date
    amount
  }
`

export const termsConditionsDocumentResult = `
  id
  version
  content
  type
  status
  updatedAt: updated_at
`

export const QUERY_OFFER_LIST = gql`
  query ($page: Int, $limit: Int, $filter: OfferFilterInput) {
    primary_sell_offers(input: { page: $page, limit: $limit, filter: $filter }) {
      total
      docs {
        ${offerResult}
      }
    }
  }
`

export const GET_OFFER = gql`
  query Offer($offerId: ID) {
    primary_sell_offer(input: { id: $offerId }) {
      ${offerResult}
    }
  }
`

export const GET_TERMS_CONDITIONS_DOCUMENT = gql`
  query termsConditionsDocument($type: String) {
    termsConditionsDocument: terms_conditions_document(input: { type: $type }) {
      ${termsConditionsDocumentResult}
    }
  }
`
